import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './changelog-version.action';

@Injectable({ providedIn: 'root' })
export class ChangelogVersionTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                version_nl: '', 
                changelogs: '', 
                is_active: null,
                created_at: '', 
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    statuses = [
        {id: "1", name: 'COMMON.active'},
        {id: "0", name: 'COMMON.inactive'}
    ];
    
    hasFilter = false;
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'version_nl', name: 'CHANGELOG_VERSION.version', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'changelogs', name: 'CHANGELOG_VERSION.changelogs', sortable: true, hasFilter: true, filter: "number"},
                { prop: 'is_active', name: 'COMMON.status', sortable: true, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name" },
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){
        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            version_nl: '', 
            changelogs: '', 
            is_active: null,
            created_at: '', 
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}